import { staticBaseUrl} from "../../config/GlobalConfig";






export default function LoginCoverBloc() {

    return (

        <div className="bloc-coadherent--cover ta-center">
            <p className="chapo bleu mb-lg">CONTRAT COLLECTIF MGP</p>
            <span className="border-fushia"></span>
            <h1 className="page-title m-y-lg">Souscrivez au contrat collectif santé de votre employeur. </h1>
            <img src={staticBaseUrl + "/img/banner-vad-collectif.jpg"} alt="espace employeur "/>
            <p className="text mt-lg">
                Bienvenue sur le parcours d'adhésion au contrat collectif santé de votre employeur. 
            </p>    
        </div>
  )
}